/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import { Stack } from "@mui/material";
import React from "react";
import ConstructionIcon from "@mui/icons-material/Construction";
import Typography from "@mui/material/Typography";

export interface PageUnderConstructionProps {
    label: string;
    breadcrumbs: JSX.Element;
}

const PageUnderConstruction = (props: PageUnderConstructionProps) => {
    const { label, breadcrumbs } = props;

    return (
        <>
            {breadcrumbs}
            <Stack direction="row" justifyContent="center" sx={{ width: "100%" }}>
                <ConstructionIcon fontSize="large" />
                <Typography sx={{ mr: 4, ml: 4 }} fontSize={24}>
                    {label} Page Under Construction
                </Typography>
                <ConstructionIcon fontSize="large" />
            </Stack>
        </>
    );
};

export default PageUnderConstruction;
